import { ICultureResources } from '../../models/resource.model';

export const koKR: ICultureResources = {
    cssVars: {
        fontFamilyTitle: 'Noto Sans KR Variable',
        fontFamilyText: 'Noto Sans KR Variable',
    },
    preloads: [
        {
            tag: 'link',
            location: 'head',
            attributes: {
                href: '/assets/fonts/noto-sans-kr/files/noto-sans-kr-latin-wght-normal.woff2',
                rel: 'preload',
                as: 'font',
                type: 'font/woff2',
                crossorigin: 'anonymous',
            },
        },
    ],
    styles: [
        {
            tag: 'link',
            location: 'head',
            persist: true,
            attributes: {
                href: '/assets/fonts/noto-sans-kr/index.css',
                rel: 'stylesheet',
            },
        },
    ],
};
